export const Bio = {
  name: "Santhosh Srinivasan",
  roles: [
    "Software Engineer",
    "Full Stack Developer",
    "ServiceNow Developer"
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/SanthoshS50",
  resume: "https://drive.google.com/file/d/1X4681y3kWJTigpw2dEdmpR0RZEHeLX2Q/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/santhosh29092001/",
  youtube:"https://www.youtube.com/@wonderaquagarden",
  insta: "https://www.instagram.com/__.sweet._.sandy._.official.__/",
  phone : "tel:+91 6385916880"
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      }
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "DataBase",
    skills: [
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      }
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Servicenow",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRSmQV0IWOvYZIMUVDOWIyS4HwGEf4lhCYyuA&s",
      },
      {
        name: "Airtable",
        image:
          "https://p7.hiclipart.com/preview/444/851/753/airtable-database-spreadsheet-logo-application-software-slack-logo.jpg",
      },
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Vercel",
        image:
          "https://w7.pngwing.com/pngs/436/888/png-transparent-vercel-hd-logo.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://uxwing.com/wp-content/themes/uxwing/download/brands-and-social-media/postman-icon.png",
      },
      {
        name: "Figma",
        image:
          "https://s3-alpha.figma.com/hub/file/1481185752/fa4cd070-6a79-4e1b-b079-8b9b76408595-cover.png",
      }
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://media.licdn.com/dms/image/v2/C4E0BAQEYClaCJxdkBw/company-logo_200_200/company-logo_200_200/0/1630617277252/ajackus_logo?e=2147483647&v=beta&t=TNIF1LNy8Wy1kG3kdrdrA5mrtO8_1LQuB9jjm9vO2IQ",
    role: "Associate Software Engineer ",
    company: "Ajackus",
    date: "April 2025 - Present",
    desc: "As a Associate Software Engineer at Ajackus, I specialize in building and customizing applications on the ServiceNow platform. My work includes designing workflows, developing custom solutions, integrating systems, and optimizing performance to meet business needs. I collaborate with teams to deliver scalable and efficient solutions while ensuring a seamless user experience.",
    skills: ["ServiceNow","ServiceNow Studio","Flow Designer","Client Scripts","Business Rules","Script Includes","REST API","UI Policies","Catalog Items","Update Sets"],
    doc: " ",
  },
  {
    id: 1,
    img: "https://media.licdn.com/dms/image/v2/C4E0BAQEYClaCJxdkBw/company-logo_200_200/company-logo_200_200/0/1630617277252/ajackus_logo?e=2147483647&v=beta&t=TNIF1LNy8Wy1kG3kdrdrA5mrtO8_1LQuB9jjm9vO2IQ",
    role: "Software Intern",
    company: "Ajackus",
    date: "November 2024 - April 2025",
    desc: "As a Software Intern at Ajackus, I was introduced to enterprise application development on the ServiceNow platform. I supported in creating basic workflows, building UI components, writing client/server scripts, and assisting in system integrations. The role helped me strengthen my fundamentals and gain hands-on experience in real-world development scenarios.",
    skills: ["HTML","CSS","Javascript","ReactJS","NodeJS","ExpressJS","MongoDB","MySQL","Git","Python"],
    doc: " ",
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ6ApOyY9hijQxrAh-SjpI4O2qehmyhE3ZDXNMb8u-NyA&s",
    role: "R&D Junior Engineer",
    company: "Elcompo Electronic Industries Private Limited",
    date: "June 2023 - Oct 2023",
    desc: "During my Three-month Tenure as an R&D Junior Engineer at Elcompo Electronics Private Limited in Chennai, I gained proficiency in AutoCAD fundamentals and honed My Skills in Transformer Designing. My hands-on experience enabled me to construct real mini transformer coils precisely to specifications, showcasing my adeptness in practical application of theoretical knowledge.",
    skills: [
      "AutoCAD",
      "Transformers"
    ],
    doc: " ",
  }
];

export const certificationcourse = [
  {
    id: 0,
    img: "https://images.g2crowd.com/uploads/product/image/large_detail/large_detail_b2b52bf26a769b861fae19c5f65643cf/guvi.png",
    role: "Full Stack Development",
    date: "Oct 2023 - Dec 2023",
    grade: " A+",
    desc: "During my time at GUVI GEEK NETWORK, I underwent comprehensive training as a MERN Stack Developer, focusing on mastering the MongoDB, Express.js, React.js, and Node.js technologies. Through a blend of theoretical learning and hands-on practical exercises, I acquired a solid understanding of both front-end and back-end development aspects.",
    company: "GUVI GEEK NETWORK PRIVATE LIMITED, IITM Research park, Tharamani, Chennai, Tamil Nadu 600 113"
  }
]

export const education = [
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTTTiwBdK1YkayfozMSKfPasT6uY9XUN63FZskvWnLwJA&s",
    school: "Anjalai Ammal Mahalingam Engineering College, kovilvenni, Thiruvarur - 614 403",
    date: "Aug 2019 - June 2023",
    grade: "8.5 CGPA",
    desc: "I am Engineering Graduate Specialized in Electronics and Communication Engineering at Anjalai Ammal Mahalingam Engineering College, kovilvenni, Thiruvarur - 614403.",
    degree: "Bachelor of Engineering - B.E, Electronics and Communication Engineering",
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSMn0JBf9O8KhNAcQzdr53jdERuzEkmSJrQyA&s",
    school: "Sri Matha Matric Higher Secondary School, Kumbakonam - 612 001",
    date: "Apr 2018 - Apr 2019",
    grade: "66.66%",
    desc: "I completed my class 12 high school education at Sri Matha Matric Higher Secondary School, Kumbakonam, where I studied Science with Computer Science.",
    degree: "HSC(XII), Computer Science",
  },
  {
    id: 3,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSMn0JBf9O8KhNAcQzdr53jdERuzEkmSJrQyA&s",
    school: "Sri Matha Matric Higher Secondary School, Kumbakonam - 612 001",
    date: "Apr 2016 - Apr 2017",
    grade: "84%",
    desc: "I completed my class 10 education at Sri Matha Matric Higher Secondary School, Kumbakonam.",
    degree: "SSLC(X)",
  },
];

export const projects = [
  {
    id: 1,
    title: "Wonder Aqua Garden E-Commerce",
    date: "Jan 2024",
    description:
      "Welcome to the Wonder Aqua Garden E-Commerce website! This project is built using the MERN stack (MongoDB, Express.js, React.js, Node.js), providing a platform for users to purchase various aquarium and pet-related products. Users can browse products, add them to their cart, review products, update their profile, and track order statuses. Additionally, an admin dashboard is available for managing products, orders, users, and inventory.",
    image:
      "https://github.com/SanthoshS50/frontend/raw/main/Readme_Images/Home.png",
    tags: [
      "React Js",
      "Bootstrap",
      "MongoDB",
      "Node Js",
      "Express Js",
      "Redux",
      "Axios",
      "EmailJS",
      "Stripe",
      "bcrypt",
      "cors",
      "dotenv",
      "JWT",
      "Nodemailer"
    ],
    category: "web app",
    github: "https://github.com/SanthoshS50/frontend",
    webapp: "https://frontend-omega-eight-94.vercel.app/",
  },
  {
    id: 2,
    title: "Find My Estate",
    date: "Feb 2024",
    description:
      "Find My Estate is a web application developed using the MERN Stack. It provides users with a platform to search for real estate properties based on their preferences and criteria. The app offers features such as property listings, advanced search filters and user authentication. With a responsive and intuitive interface, users can easily browse, compare, and inquire about available properties.",
    image:
      "https://github.com/SanthoshS50/Find_My_Estate/raw/main/Readme_Images/Home%20Page.png",
    tags: [
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Redux",
      "bcryptjs",
      "dotenv",
      "JWT",
      "Tailwindcss",
      "Firebase"
    ],
    category: "web app",
    github: "https://github.com/SanthoshS50/Find_My_Estate",
    webapp: "https://find-my-estate.onrender.com/",
  },
  {
    id: 3,
    title: "Techie's Blog",
    date: "March 2024",
    description:
      "Techie's Blog is a MERN stack web application designed for tech enthusiasts to share insights, tutorials, and updates on the latest trends in the tech industry. It features user authentication for writers to create and manage their own blog posts, along with commenting and liking functionalities for community engagement. The app incorporates responsive design and intuitive navigation for seamless browsing across devices. With a focus on user-generated content, Techie's Blog fosters a vibrant community of tech enthusiasts exchanging knowledge and ideas. It also utilizes MongoDB for efficient data storage, Express.js for server-side logic, React.js for dynamic front-end development, and Node.js for backend functionality.",
    image:
      "https://github.com/SanthoshS50/Techies_Blog/raw/main/Readme_Images/TB-Home.png",
    tags: [
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Redux",
      "bcryptjs",
      "dotenv",
      "JWT",
      "Tailwindcss",
      "Firebase"
    ],
    category: "web app",
    github: "https://github.com/SanthoshS50/Techies_Blog",
    webapp: "https://techies-blog.onrender.com/"
  },
  {
    id: 4,
    title: "Chat App",
    date: "July 2024",
    description:
      "The Chat App allows users to securely send and receive text messages with a fully responsive design and a scalable architecture, this application ensures a seamless user experience across devices. The backend is powered by Node.js and Express.js, with MongoDB handling data storage. Real-time communication is achieved through WebSockets using Socket.io, making the chat experience smooth and instant. This project showcases my ability to develop full-stack applications with a focus on performance and user experience. ",
    image:
      "https://github.com/SanthoshS50/Chat_App/raw/main/Readme_Images/Homepage.png",
    tags: [
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Redux",
      "bcryptjs",
      "dotenv",
      "JWT",
      "Tailwindcss",
      "Socket.Io"
    ],
    category: "web app",
    github: "https://github.com/SanthoshS50/Chat_App",
    webapp: "https://chat-app-im1b.onrender.com/"
  },
  {
    id: 5,
    title: "Job Portal",
    date: "September 2024",
    description:
      "This is a comprehensive job portal built using the MERN stack, designed to streamline the job search and recruitment process for both job seekers and employers. For job seekers, the platform offers features such as job browsing, searching with filters based on location, job title, and category, and the ability to apply directly to postings. Users can manage their applications, view job details, and track the status of their submissions from their personalized dashboards. For employers, the portal allows companies to post job vacancies, review applicants, and manage the recruitment pipeline efficiently. Employers can view the profiles of applicants, track applications, and communicate with candidates directly through the platform. With user authentication, secure data handling, and a responsive UI, this job portal delivers a seamless and dynamic experience for all users involved in the hiring process.",
    image:
      "https://github.com/SanthoshS50/mern-jobportal/raw/main/Readme_Images/Homepage.png",
    tags: [
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Redux",
      "bcryptjs",
      "dotenv",
      "JWT",
      "Tailwindcss",
      "Cloudinary"
    ],
    category: "web app",
    github: "https://github.com/SanthoshS50/mern-jobportal",
    webapp: "https://mern-jobportal-rgf3.onrender.com"
  }
];

